import { baseApiCall } from "./BaseApiCall";

type ClientGroup = "MM" | "BLOOMS" | "ALDI";

const getApiBaseUrl = (clientGroup: ClientGroup): string => {
  switch (clientGroup) {
    case "MM":
      return `${process.env.REACT_APP_API_COMMON}`;
    case "BLOOMS":
      return `${process.env.REACT_APP_API_BLOOMS}`;
    case "ALDI":
      return `${process.env.REACT_APP_API_ALDI}`;
    default:
      return `${process.env.REACT_APP_API_COMMON}`;
  }
};

const getApiVersionUrl = (clientGroup: ClientGroup): string => {
  return `${getApiBaseUrl(clientGroup)}api/v1`;
};

// Example: getQuizQuestions for a given client group
export const ApiGetQuizQuestions = (clientGroup: ClientGroup) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}report/quiz/get-quiz-question`;

  return baseApiCall({
    url,
    method: "get",
  });
};

export const ApiReportList = (
  page: number,
  rowsperpage: number,
  reportMonth: number,
  reportYear: number,
  reportstatusId: number,
  clientGroup: any,
  clientEntityId:any
) => {
  // console.log(clientGroup);
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/report-list?offset=${page*rowsperpage}&limit=${rowsperpage}&reportMonth=${reportMonth}&reportYear=${reportYear}&reportStatusId=${reportstatusId}&projectGroupName=${clientGroup}${(clientEntityId.value !== ' ') ? `&clientEntityId=${clientEntityId.value}`:'' }`;
  return baseApiCall({
    url: url,
    method: "get",
  });
};

export const ApiCallGetReportDetails = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/report-details${data}`;
  return baseApiCall({
    url: url,
    method: "get",
  });
};

export const ApiScoreCardStep1 = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-scorecard`;
  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiScoreCardStep2 = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-scorecard-questions`;
  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiScoreCardStep3 = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-scorecard-invoice-location`;
  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiUpdateReportStatus = (data: any,  clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/update-report-status`;
  return baseApiCall({
    url: url,
    method: 'put',
    data
  })
}
export const ApiDeleteReport = (data: any,  clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/delete-report`;
  return baseApiCall({
    url: url + data,
    method: 'del',
  })
}

export const ApiShopperFeedback = (reportHeaderId: number, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/get-shopper-feedback?reportHeaderId=${reportHeaderId}`;
  return baseApiCall({
    url: url,
    method: 'get',
  })
}

export const ApiPostShopperFeedback = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/add-shopper-feedback`;
  return baseApiCall({
    url: url,
    method: 'post',
    data
  })
}
